module.exports = __webpack_public_path__ + "img/sjs-4.753c258c.png";